import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { trackEvent } from '../../utils/tracking'

import InputGroup from './InputGroup'
import Checkbox from './Checkbox'

import { emailCollectionConfigs } from '../../config/email'

import {
  postEmailToMailchimp,
  postEmailToMailchimpAndSheets
} from '../../utils/email'

class EmailCollection extends Component {
  constructor () {
    super()
    this.state = {
      optedInToNewsletter: false
    }
    this._handleSubmit = this._handleSubmit.bind(this)
  }
  render () {
    const { label, autoFocus, optInNewsletter } = this.props
    const { optedInToNewsletter } = this.state
    return (
      <form className='newsletter-collection' onSubmit={this._handleSubmit}>
        {label && (
          <label className='newsletter-collection__label block mb1'>
            {label}
          </label>
        )}
        <InputGroup
          inputType='email'
          inputRefFn={e => {
            if (e) {
              this._emailInputElement = e
            }
          }}
          placeholder='Enter your email'
          autoComplete
          autoFocus={autoFocus}
          buttonType='submit'
        />
        {optInNewsletter && (
          <label>
            <Checkbox
              checked={optedInToNewsletter}
              onChange={() =>
                this.setState({ optedInToNewsletter: !optedInToNewsletter })}
            />{' '}
            Also give me the latest AI tech with the weekly newsletter
          </label>
        )}
      </form>
    )
  }
  _handleSubmit (e) {
    e.preventDefault()
    const {
      afterSubmit,
      collectionConfig,
      trackingLabel,
      trackingContext
    } = this.props
    const { optedInToNewsletter } = this.state
    const emailRef = this._emailInputElement
    const email = emailRef.value

    postEmailToMailchimpAndSheets(email, collectionConfig)
    if (
      optedInToNewsletter &&
      emailCollectionConfigs.newsletter.mailchimpListId
    ) {
      // if adding to two lists simultaneously; only send confirmation letter for one of them
      postEmailToMailchimp(
        email,
        emailCollectionConfigs.newsletter.mailchimpListId,
        'subscribed'
      )
    }

    // clear input
    emailRef.value = ''

    if (typeof afterSubmit === 'function') {
      afterSubmit(email)
    }

    let finalTrackingLabel = trackingLabel || 'emailCollection'
    if (optedInToNewsletter) {
      finalTrackingLabel += 'WithOptInNewsletter'
    }
    if (trackingContext) {
      finalTrackingLabel += `-${trackingContext}`
    }

    trackEvent(finalTrackingLabel)
  }
}

EmailCollection.propTypes = {
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  collectionConfig: PropTypes.shape({
    googleSpreedsheet: PropTypes.shape({
      url: PropTypes.string.isRequired,
      ids: PropTypes.shape({
        email: PropTypes.string.isRequired
      }).isRequired
    }),
    mailchimpListId: PropTypes.string
  }),
  optInNewsletter: PropTypes.bool,
  afterSubmit: PropTypes.func,
  // tracking
  trackingContext: PropTypes.string,
  trackingLabel: PropTypes.string
}

export default EmailCollection



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/EmailCollection.js